export default "__VITE_ASSET__Czj_bZWl__"